import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";

import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";

import Help from "./Help";

import ErrorWrapper from "error/index";

import { DomainContext } from 'layouts/LayoutContext';
import { DomainList } from "data/domain"

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});


/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
const DesktopContainer = () => {
  const location = useLocation();
  const hasMountedRef = useRef(false);
  useEffect(() => { hasMountedRef.current = true; }, []);

  return (

    <Media
      greaterThan="mobile"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* <SideBar /> */}
      {/* <TopBar /> */}

      <div
        style={{
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            maxWidth: 1400,
            width: "100vw",
            paddingLeft: 68,
            paddingTop: 37,
            paddingRight: 30,
          }}

        >

          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={location.pathname}
              initial={hasMountedRef.current ? { opacity: 0, y: 8 } : false}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
              style={{ willChange: "opacity, transform" }}
            >
              <ErrorWrapper>
                <Outlet />
              </ErrorWrapper>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </Media>

  )

};

const MobileContainer = () => {
  const location = useLocation();
  const hasMountedRef = useRef(false);
  useEffect(() => { hasMountedRef.current = true; }, []);

  return (
    <Media at="mobile" style={{ position: "relative" }}>
      {/* <MobileNav /> */}
      <div
        style={{
          width: "100%",
          marginTop: "100px",
          maxWidth: "100%",
          overflowX: "hidden",
          padding: 10,
        }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            initial={hasMountedRef.current ? { opacity: 0, y: 8 } : false}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            style={{ willChange: "opacity, transform" }}
          >
            <ErrorWrapper>
              <Outlet />
            </ErrorWrapper>
          </motion.div>
        </AnimatePresence>
      </div>
      <Help />
    </Media>
  )
}

const ResponsiveContainer = ({ children }) => {
  /* Heads up!
   * For large applications it may not be best option to put all
   * page into these containers at
   * they will be rendered twice for SSR.
   */
  const domain = window.location.host;
  // console.log(domain)
  // console.log(DomainList?.[domain])
  return (
    <MediaContextProvider>
      <DomainContext.Provider value={
        DomainList?.[domain] ? DomainList?.[domain] : Object.values(DomainList)[0]}>
        <DesktopContainer>{children}</DesktopContainer>
        <MobileContainer>{children}</MobileContainer>
      </DomainContext.Provider>
    </MediaContextProvider>
  );
};

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

export default ResponsiveContainer;
